module.exports = __webpack_public_path__ + "img/2.7d3ef3ab.png";